import React, { useState } from 'react';
import { Text, Icon } from '@/ui-kits';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { formatDate } from '@/utils/common_functions';

interface AISummaryProps {
  summary: string;
  prev_summary?: string;
  prev_case_close_at?: string;
}

const AISummary: React.FC<AISummaryProps> = props => {
  const { summary, prev_case_close_at, prev_summary } = props;
  const [summaryOpen, setSummaryOpen] = useState<boolean>(false);

  return (
    <div className="bg-[#F0F9FF] flex items-start gap-2 sm:gap-3 rounded-lg border border-ui_blue_light/80 p-4 sm:p-6">
      <Icon type="ai_icon" className="size-5 sm:size-6 flex-shrink-0 mt-1" />
      <div className="flex-1">
        <Text variant='title' className="text-ui_blue mb-1">AI-Generated Summary</Text>
        <Text className="font-FigtreeRegular !text-xs sm:!text-sm text-ui_input_border_dark mb-3 sm:mb-4">Automatically generated for your reference</Text>
        <Text className="font-FigtreeRegular !text-xs sm:!text-sm text-ui_blue leading-relaxed mb-3 sm:mb-4">{summary}</Text>
        <Text className="font-FigtreeSemiBold !text-xs sm:!text-sm text-ui_input_border_dark">Note: This section is view-only and will not be shared with the patient.</Text>

        {prev_summary && <div className='h-[1px] bg-ui_bootom_border my-4' />}

        {prev_summary && <div className=''>
          <button onClick={() => setSummaryOpen(p => !p)} className='w-full flex justify-between items-center'>
            <Text variant='subtitle' className='text-palette-ui_input_border_dark'>Previous Case AI Summary</Text>
            {summaryOpen ? (
              <ChevronUp className="size-6 text-ui_blue" />
            ) : (
              <ChevronDown className="size-6 text-ui_blue" />
            )}
          </button>
          {prev_case_close_at && <Text variant="body" className='text-ui_input_border_dark'>(Last Consultation · {formatDate(prev_case_close_at, 'dd MMM yyyy')})</Text>}
          {
            summaryOpen && <Text variant='small' className='text-ui_input_border_dark mt-4'>
              {prev_summary}
            </Text>
          }
        </div>}
      </div>

    </div>
  );
};

export default AISummary;
